import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import LocalTexts from '../../../../ulezTextV2.json';

import styles from './Heading.scss';

type ComplianceResources = {
  icon: React.ReactElement;
  key: string;
}

export type HeadingProps = {
  complianceInfo: ComplianceResources;
  hasComplianceStatus: boolean;
  isCompliant: boolean | null;
  isEuroStatus3: boolean;
};

const LocalT = new MDText(LocalTexts);

export const Heading = ({
  complianceInfo,
  hasComplianceStatus,
  isCompliant,
  isEuroStatus3,
}: HeadingProps) => (
  <div className={cx(styles.heading, {
    [styles.notCompliant]: hasComplianceStatus && !isCompliant,
    [styles.notAvailable]: isCompliant === null,
    [styles.euroStatus3]: isEuroStatus3,
  })}>
    <div className={styles.iconWithTitle}>
      <span className={cx(styles.icon, {
        [styles.notCompliant]: hasComplianceStatus && !isCompliant,
        [styles.notAvailable]: isCompliant === null,
        [styles.euroStatus3]: isEuroStatus3,
      })}
      >
        {complianceInfo.icon}
      </span>
      <h2>{LocalT.translate(`results.${complianceInfo.key}.title`)}</h2>
    </div>
    <div>
      { hasComplianceStatus && (
        <p>
          {LocalT.translate(`results.${complianceInfo.key}.subtitle`, {
            fee: (<span className={styles.fee}>{LocalT.translate('results.fee')}</span>),
          })}
        </p>
      )}
      {(isCompliant === null || isEuroStatus3) && (
        <p>
          {LocalT.translate(`results.${complianceInfo.key}.subTitle`)}
        </p>
      )}
    </div>
  </div>
);

export default Heading;
